import { FC, SyntheticEvent } from 'react';
import { DivertsAttribute } from 'models/husqiotbus';
import { SelectListItem } from './styled';
import Checkbox from 'components/UI/Checkbox';

type Props = {
  onCheckboxChange: (name: DivertsAttribute) => (value: SyntheticEvent) => void;
};

const EnvironmentSelector: FC<Props> = ({ onCheckboxChange }) => {
  return (
    <SelectListItem>
      <Checkbox
        id={'dev'}
        value="dev"
        onChange={onCheckboxChange(DivertsAttribute.Dev)}
      />
      <label htmlFor={'dev'}>dev</label>
      <Checkbox
        id={'qa'}
        value="qa"
        onChange={onCheckboxChange(DivertsAttribute.Qa)}
      />
      <label htmlFor={'qa'}>qa</label>
      <Checkbox
        id={'live'}
        value="live"
        onChange={onCheckboxChange(DivertsAttribute.Live)}
      />
      <label htmlFor={'live'}>live</label>
    </SelectListItem>
  );
};

export default EnvironmentSelector;
